import React from 'react'
import styles from './LineTrace.module.scss'

const LineTrace = () => {
  return <div className={styles.dashed} />
}

export default React.memo(LineTrace)
